import PostInfo from './PostInfo';

customElements.define('post-info', PostInfo);
